tetloose.magnificPopup = function () {
    $('.content').magnificPopup({
        delegate: 'a',
        type: 'image'
    });
};
